import { render, staticRenderFns } from "./MODEL-WAR.vue?vue&type=template&id=ac434c2a&"
import script from "./MODEL-WAR.vue?vue&type=script&lang=js&"
export * from "./MODEL-WAR.vue?vue&type=script&lang=js&"
import style0 from "./MODEL-WAR.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports